import { useLayoutEffect, useRef, useState } from 'react'

/**
 * line-clamp による省略(…)が起きているかを判定する。
 * 省略が起きているときだけ tooltip を出す、といった出し分けに使う。
 * text 変更とリサイズの両方で測り直す。
 */
export const useIsTextClamped = (text: string) => {
  const ref = useRef<HTMLElement | null>(null)
  const [isClamped, setIsClamped] = useState(false)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) {
      return
    }
    // 端数の丸め誤差を避けるため 1px の許容を持たせる。
    const measure = () => {
      setIsClamped(element.scrollHeight > element.clientHeight + 1)
    }
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(element)
    return () => observer.disconnect()
  }, [text])

  return { ref, isClamped }
}
